import { IconClipboardCheck } from "@tabler/icons-react";
import { Card, Stack, Text, ThemeIcon } from "@/components/ui";

export function HistorialVacioCard() {
  return (
    <Card padding="xl">
      <Stack gap="sm" align="center" className="text-center">
        <ThemeIcon variant="filled" color="multiva" size="lg" radius="xl">
          <IconClipboardCheck size={24} stroke={1.6} />
        </ThemeIcon>
        <Text fw={600}>Aún no has autorizado ninguna solicitud</Text>
        <Text size="sm" c="dimmed" className="max-w-105">
          Cuando autorices un nivel desde la bandeja, la firma quedará registrada
          aquí · podrás consultarla en cualquier momento.
        </Text>
      </Stack>
    </Card>
  );
}
